<section style="background-image:url('{{contentLeadGen.backgroundImg}}');background-size: 120% 120%;" #leadGenView *ngIf="!isSubscribed">
    <div class="title-and-ctas">
        <div *ngIf="!isLoggedOrSubscribe;else thanksMessage">
            <h1>{{contentLeadGen.signUpTitle}}</h1>
            <p>{{contentLeadGen.signUpParagraph}}</p>
            <div class="ctas">
                <button class="cta" (click)="message();">{{contentLeadGen.ctaButtonText}}</button>
            </div>
        </div>
        <ng-template #thanksMessage>
            <h1>{{contentLeadGen.thanksTitle}}</h1>
            <p>{{contentLeadGen.thanksParagraph}}</p>
        </ng-template>
    </div>
</section>
